import { initials } from '../../lib/merchant/format';

type AvatarSize = 'md' | 'lg';

// `.avatar-md` = 44px/16px, `.avatar-lg` = 56px/20px (mockup).
const SIZE: Record<AvatarSize, string> = {
  md: 'h-11 w-11 text-[16px]',
  lg: 'h-14 w-14 text-[20px]',
};

/**
 * Mockup avatar: solid eerie-black circle with the name's `initials`
 * (list/card variant). Defaults to `md`.
 */
export function Avatar({ name, size = 'md' }: { name: string; size?: AvatarSize }): JSX.Element {
  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center rounded-full bg-[var(--m-bg-inverse)] font-bold text-[var(--m-fg-on-brand)] ${SIZE[size]}`}
      aria-hidden="true"
    >
      {initials(name)}
    </span>
  );
}
